import { render, staticRenderFns } from "./ProductIconShiny.vue?vue&type=template&id=965caca2&scoped=true&"
import script from "./ProductIconShiny.vue?vue&type=script&lang=js&"
export * from "./ProductIconShiny.vue?vue&type=script&lang=js&"
import style0 from "./ProductIconShiny.vue?vue&type=style&index=0&id=965caca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965caca2",
  null
  
)

export default component.exports